"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const DEFAULT_CLASS = 'red thin10 nofill ';
exports.DEFAULT_CLASS = DEFAULT_CLASS;
//# sourceMappingURL=default-class.js.map